import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { Sitemap } from 'pages';
import { Link } from 'react-router-dom'

import { connect } from 'react-redux'
import loadingStatuss from 'actions/LoadingActions'

const QUERY = gql`
  query PageQuery($lang: String!) {
      sitemap(lang: $lang) {
        _id
        level
        menu_order
        path
        title
        parent
        rewrite_source
        rewrite_url
        rewrite_target
      }
  }
`
const queryOptions = {
  options: ({ lang, postId, init_page, skip }) => ({
    fetchPolicy: 'cache-first',
    skip: (skip || false),
    variables: {
      postId: postId,
      lang: (lang || 'lv')
    }
  }),
  props: props => {
    const { data } = props
    return {
      ...{
        // padodam prosus
        sitemap: data.sitemap,
        // page: data.language.page,
        loading: data.loading
        // networkStatus: data.networkStatus
      // refetchSiteMap: data.refetch
      }
    }
  }
}

class Page extends React.PureComponent {
   constructor(props) {
    super(props)
  }
  componentWillMount() {
    if(this.props.loading){
        this.props.loadingStatuss({_id:this.props.path+'__',loading:true})  
    } else if(!this.props.loading && this.props.global_loading && this.props.global_loading[this.props.path+'__']===true){
        this.props.loadingStatuss({_id:this.props.path+'__',loading:false})    
    }
  }
  
  componentWillReceiveProps(nextProps) {
     if(nextProps.loading && nextProps.global_loading[nextProps.path+'__']===false){
        nextProps.loadingStatuss({_id:nextProps.path+'__',loading:true})  
     } else if(!nextProps.loading && nextProps.global_loading[nextProps.path+'__']===true){
        nextProps.loadingStatuss({_id:nextProps.path+'__',loading:false})    
     }
  }

 render() {
      const props = this.props

      if(props.loading){
        return null
      }

      return <Sitemap {...props} />
  }
}



const mapStateToProps = state => {
  // console.log(state)
  return ({
    global_loading: state.global_loading,
  })
}
const mapDispatchToProps = dispatch => ({
  loadingStatuss: LOADING => {
    dispatch(loadingStatuss(LOADING))
  }
})

export default compose(
  graphql(QUERY, queryOptions),
  connect(mapStateToProps, mapDispatchToProps)
)(Page)





// WEBPACK FOOTER //
// ./src/components/PageSitemap.js